// THIS IS MORRIS ORIGINAL LAYOUT FUNCTION

export const LAYOUT = {
    EXTRA_SMALL: 'extra_small',
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    EXTRA_LARGE: 'extra_large',
    EXTRA_EXTRA_LARGE: 'extra_extra_large',
};

export const SMALL_WIDTH = 476;
export const MEDIUM_WIDTH = 768;
export const LARGE_WIDTH = 992;
export const EXTRA_LARGE_WIDTH = 1200;
export const EXTRA_EXTRA_LARGE_WIDTH = 1440;

export const getCurrentLayout = (width: number): string => {
    if (width < SMALL_WIDTH) {
        return LAYOUT.EXTRA_SMALL;
    } else if (width >= SMALL_WIDTH && width < MEDIUM_WIDTH) {
        return LAYOUT.SMALL;
    } else if (width >= MEDIUM_WIDTH && width < LARGE_WIDTH) {
        return LAYOUT.MEDIUM;
    } else if (width >= LARGE_WIDTH && width < EXTRA_LARGE_WIDTH) {
        return LAYOUT.LARGE;
    } else if (width >= EXTRA_LARGE_WIDTH && width < EXTRA_EXTRA_LARGE_WIDTH) {
        return LAYOUT.EXTRA_LARGE;
    } else {
        return LAYOUT.EXTRA_EXTRA_LARGE;
    }
};
